module.exports = __webpack_public_path__ + "static/media/circle-question-solid.f82d2edf.png";